export const N10nPrioritiesEnum = {
  normal: "normal",
  warning: "warning",
  critical: "critical",
};
